import { AdaptivePracticeContext, AppContext } from "../../../context/context";
import { PlayFrame } from "../frame/PlayFrame";
import { ContentFactoryImpl, Content } from '@mathbuddy/adaptive-practice-engine';
import { getTimeSpent } from '../../../utils/utils';
import { Component } from "react";
import { StatusCodes } from "http-status-codes";
import apis from "../../../apis/api";
import { adaptivePracticeActions } from "../../../reduxStore";
import { connect } from "react-redux";
import { LiveSession } from "./liveSession";
import { ls } from "../../../localStorage";
import { applyTheme, resolveTheme } from '../theme';
import { themeImage } from '../theme';



class RiseSessionForStudents extends Component<any, any> {
    static contextType = AppContext;
    context!: { windowHeight: string, windowWidth: string, messageForParent: any, navigateTo: any };
    constructor(props: any) {
        super(props)
        this.state = {
            // Optional `theme` prop from the parent; falls back to this screen's own
            // default. Resolved once - the theme cannot change between questions.
            theme: resolveTheme(props.theme),
            currentUser: this.props.currentUser,
            sessionInfo: this.props.sessionInfo,
            skillId: this.props.skillId,
            langObj: { number_lang: '', lang: '' },
            contentFactoryObj: new ContentFactoryImpl(),
            contentObj: new Content(),
            liveSession: new LiveSession(
                this.props.sessionInfo.sessionId,
                this.props.sessionInfo.sessionNo,
                this.props.sessionInfo.batchId,
                this.props.currentUser.id
            ),
            isShowCorrectAnswerAnimation: false,
            isPractice: false,
            isNewSession: true,
            isLoader: false,
            isCoinAnimation: false,
            practiceCount: 0,
            coins: 0,
            streaks: 0,
            adaptivePracticeLevel: '',
            completedStatusPercentage: 0,
            currentQuestionPosition: 0,
            startTime: 0,
            totalCorrectAttemptedQuestion: 0,
            totalAttemptedQuestions: 0,
            totalAttemptedCount: 0,
            accuracy: 0,
            notificationMessage: '',
            response: { component: [] },
            questionSkill: {},
            currentQuestion: {} as { id: string, skill_id: string, safeZone?: boolean, reviewObj: any },
            questionsList: [] as { id: string, skill_id: string }[],
            lastResponses: { questions: [] },
            isShowAdaptivePopup: false,
            isShowStartPopup: false,
            isCloseFromClick: false,
            isSafeZone: false,
            isLastQuestion: false,
        }
    }

    componentDidMount = () => {
        // Paint the frame ONCE per screen - 21 custom properties, not a per-question cost.
        applyTheme(this.state.theme);
        this.getLatestStateOnMount();
    }


    getLatestStateOnMount = async () => {
        await this.sendLastAttemptedIfAny(); // if window is reloaded and last attempted questions is there send it to DB.
        this.setState({ isLoader: true });

        let sessionStatus = await this.getSessionStatus();
        let streaksAndCoins = await this.getStreaksAndCoins();
        let currentUser = this.props.currentUser;
        let country_code = currentUser.country_code;

        let langObj = { number_lang: 'en', lang: this.props.lang + '_' + country_code.toLowerCase() };


        const userObj = {
            env: process.env.REACT_APP_ENV, userId: currentUser.id,
            classroomId: currentUser.classroom_id,
            dbToken: currentUser.dbToken, token: ls.getToken()
        };
        const sessionInfo = this.state.sessionInfo;

        const questionsList = sessionInfo.isLiveMode ?
            await this.state.contentObj.getReasoningZoneQuestionsById(sessionInfo.adaptiveId) :
            await this.state.contentObj.getReasoningZoneQuestionsByUser(userObj,
                sessionInfo.sessionId, sessionInfo.adaptiveId);

        this.setState({
            ...sessionStatus,
            ...streaksAndCoins,
            langObj,
            isLoader: false,
            questionsList
        }, () => {
            if (!this.state.isShowStartPopup)
                this.loadSessionContent();
        })
    }

    getSessionStatus = async () => {
        let returnObj = {
            totalAttemptedCount: 0,
            totalCorrectAttemptedQuestion: 0,
            isPractice: false,
            isShowStartPopup: false,
        }

        if (this.state.sessionInfo.isLiveMode) {
            return returnObj; // In live mode we don't need to fetch session status from API.
        }

        const user_id = this.state.currentUser.id;
        const session_id = this.state.sessionInfo.sessionId;
        let skillStatusRes = await apis._getAdaptiveSessionStatus(user_id, session_id);

        //console.log(skillStatusRes);
        if (skillStatusRes?.data?.code === StatusCodes.OK) {
            const sessionStatus = skillStatusRes.data.result;
            if (sessionStatus) {
                returnObj.totalAttemptedCount = sessionStatus.total_questions;
                returnObj.totalCorrectAttemptedQuestion = sessionStatus.correct_answers;
                returnObj.isPractice = sessionStatus.isCompleted ? true : false;
                returnObj.isShowStartPopup = returnObj.isPractice;
            }
        }

        return returnObj;
    }

    getStreaksAndCoins = async () => {
        let returnObj = { coins: 0, streaks: 0 };

        let currentUser = this.state.currentUser;
        let dashboardSummary = await apis._getLastUserSummary(currentUser.id);
        if (dashboardSummary.status === StatusCodes.OK && dashboardSummary.data.result.length > 0) {
            let lastSummary = dashboardSummary.data.result[0];

            returnObj.coins = lastSummary.total_coins
            returnObj.streaks = lastSummary.current_streak;
        }

        return returnObj;
    }

    loadSessionContent = async () => {
        try {
            this.setState({ isLoader: true, response: { component: [] } });

            const sessionInfo = this.state.sessionInfo;
            const currentQuestionPosition = this.state.currentQuestionPosition;
            const langObj = this.state.langObj;

            let currentQuestion: { id: string, skill_id: string, safeZone?: boolean, reviewObj: any };

            if (sessionInfo.isLiveMode) {

                const question_id = this.props.sessionInfo.question_id[0].split('_');
                currentQuestion = {
                    id: question_id[0],
                    skill_id: question_id[1],
                    safeZone: false, //always false in live class
                    reviewObj: {}
                };

                const txns = await this.state.liveSession.getQuestionTxn([{ qId: currentQuestion.id, loId: currentQuestion.skill_id }]);
                const currentQuestionTxn = (txns.length > 0) ? txns[0] : {};
                console.log("txns", currentQuestionTxn);

                currentQuestion.reviewObj = currentQuestionTxn.reviewObj ? JSON.parse(currentQuestionTxn.reviewObj) : {};
            }
            else {
                currentQuestion = this.state.questionsList[currentQuestionPosition];
                currentQuestion = { ...currentQuestion, reviewObj: {} };

                // If safeZone question comes first time show start safeZone popUp;
                if (currentQuestion.safeZone && !this.state.isSafeZone) {
                    const isShowStartPopup = !this.state.isPractice;
                    this.setState({ isLoader: false, isShowStartPopup, isSafeZone: true })
                    if (isShowStartPopup)
                        return; // Show PopUp for safezone no need to load question;
                }
            }

            let isLastQuestion = (currentQuestionPosition === (this.state.questionsList.length - 1));
            let adaptivePracticeLevel = sessionInfo.isLiveMode ? '' : 'Question ' + (currentQuestionPosition + 1);

            let completedStatusPercentage = Math.round(((currentQuestionPosition) * 100) / this.state.questionsList.length);
            let accuracy = Math.round((this.state.totalCorrectAttemptedQuestion * 100) / (this.state.totalAttemptedCount)) || 0;

            await this.state.contentObj.loadSkillBySkillId(currentQuestion.skill_id, this.state.theme, langObj.lang);

            let response = await this.state.contentFactoryObj.displayQuestion(this.state.contentObj,
                this.state.contentObj.createContentTemplateObject(currentQuestion.id, 'REACT_WEB'), langObj, currentQuestion.reviewObj);
            console.log("response_skills", response, this.state.lastResponses);

            this.setState({
                startTime: new Date(),
                currentQuestion,
                adaptivePracticeLevel,
                completedStatusPercentage,
                response,
                accuracy,
                isLastQuestion
            }, () => {
                //console.log(this.state);
                this.setState({ isLoader: false });
            })

        } catch (error) {
            this.setState({ isLoader: false })
        }
    }

    getNotificationMessage = (streak: number) => {
        let message = ''
        if (streak > 0 && (streak % 2) === 0) {
            message = (streak < 10) ? `${streak} in a row!` :
                (streak < 20) ? `You are on a roll! ${streak} in a row` :
                    (streak <= 22) ? `Bravo! ${streak} in a row` :
                        `Way to go. ${streak} in a row`;
        }
        return message;
    }

    saveQuestionResponse = async (answerObj: { givenAnswer: any, actualAnswer: any, isCorrectAns: Boolean }, clickCount: number) => {
        const currentQuestion: { id: string, skill_id: string, reviewObj: any } = this.state.currentQuestion;
        const isStreakFreeze = this.state.sessionInfo.isLiveMode;
        const isCorrectAns = answerObj.isCorrectAns;
        const isSafeZone = this.state.isSafeZone;
        const isLastQuestion = this.state.isLastQuestion;

        let coins = (isCorrectAns) ? (this.state.coins + 1) : this.state.coins;
        let streaks = (isStreakFreeze) ? this.state.streaks : // no gain and no loss
            (isCorrectAns) ? (this.state.streaks + 1) : //gain on correct answer
                isSafeZone ? this.state.streaks : //no loss on wrong answer for safeZone
                    0;// reset 

        let time_spent = getTimeSpent(this.state.startTime);
        let currentQuestionPosition = (isSafeZone || isCorrectAns || clickCount > 1) ?
            (this.state.currentQuestionPosition + 1) :
            (this.state.currentQuestionPosition);

        let completedStatusPercentage = Math.round(((currentQuestionPosition) * 100) / this.state.questionsList.length);
        let notificationMessage = isCorrectAns ? this.getNotificationMessage(streaks) : '';

        let isShowAdaptivePopup = (isLastQuestion && currentQuestionPosition === this.state.questionsList.length) ? true : false;
        let isShowCorrectAnswerAnimation = this.state.sessionInfo.isLiveMode && isCorrectAns;
        let totalCorrectAttemptedQuestion = (isCorrectAns) ? this.state.totalCorrectAttemptedQuestion + 1 : this.state.totalCorrectAttemptedQuestion;

        let totalAttemptedQuestions = (isSafeZone || isCorrectAns || clickCount > 1) ? this.state.totalAttemptedQuestions + 1
            : this.state.totalAttemptedQuestions;

        let totalAttemptedCount = this.state.totalAttemptedCount + 1;
        let accuracy = Math.round((totalCorrectAttemptedQuestion * 100) / totalAttemptedCount) || 0;

        this.setState({
            isCoinAnimation: isCorrectAns, coins, streaks, completedStatusPercentage, currentQuestionPosition,
            notificationMessage, totalCorrectAttemptedQuestion, totalAttemptedQuestions, accuracy, totalAttemptedCount,
            isShowCorrectAnswerAnimation, isShowStartPopup: false, isCloseFromClick: false
        },
            () => {
                setTimeout(() => {
                    this.setState({ isCoinAnimation: false, isShowCorrectAnswerAnimation: false, notificationMessage: '', isShowAdaptivePopup })
                    /* if (isShowAdaptivePopup)
                       this.playMusic('successSound');*/
                }, 1700)
            });

        let lastAttemptedData = this.props.adaptivePracticeReducer.sessionLastAttemptedQuestion;
        let currentAnswer = [{ "isCorrect": answerObj.isCorrectAns, "answer": answerObj.givenAnswer }];
        console.log("currentQuestion", currentQuestion);
        let data = {
            "questions": [{
                "isNewSession": this.state.isNewSession,
                "user_id": this.state.currentUser.id,
                "session_id": this.state.sessionInfo.sessionId,
                "lo_id": currentQuestion.skill_id,
                "question_id": currentQuestion.id,
                "review_obj": this.state.response.reviewObj,
                "number_lang": this.state.langObj.number_lang,
                "lang": this.state.langObj.lang,
                "answers": [...lastAttemptedData.questions[0].answers, ...currentAnswer],
                "isCorrect": answerObj.isCorrectAns,
                "isStreakFreeze": isStreakFreeze,
                "isSafeZone": isSafeZone,
                "blooms": this.state.response.blooms,
                "time_spent": lastAttemptedData.questions[0].time_spent + time_spent,
            }],
            qualifier: "SESSION",
            sessionNumber: this.state.sessionInfo.sessionNo,
            sessionQuestionIds: this.state.questionsList.map((q: { id: string, skill_id: string }) => `${q.id}_${q.skill_id}`)
        }

        if (!isSafeZone && clickCount === 1 && !answerObj.isCorrectAns) {
            this.props.setAPLastAttempted(data);
            return  // return from here if answer is incorrect in the first attempt and not a safe zone question.
        }

        this.setState({ isNewSession: false },
            async () => {
                let response = await this.saveQuestionResponseToDB(data);
                // console.log(response);
                if (response?.status === StatusCodes.OK) {
                    if (!this.state.sessionInfo.isLiveMode && isCorrectAns && !isShowAdaptivePopup)
                        this.loadSessionContent();
                }
            });
    }

    saveQuestionResponseToDB = async (data: any) => {
        // console.log(data);
        let response = await apis._saveQuestionResponseForAdaptiveSession(data);
        if (response?.status === StatusCodes.OK) {
            this.props.setAPDefaultLastAttempted();// set default last attempted question with empty answer array.
            this.context.messageForParent('updateUserReducerForAdaptiveSession', {
                questions: data.questions, //This becouse we are storing one question at a time.
            })
        }
        return response;
    }

    getPopUpInfo = () => {
        let accuracy = this.state.accuracy;
        let remainingQuestion = (!this.state.isShowStartPopup && this.state.questionsList.length) ?
            this.state.questionsList.length - this.state.totalAttemptedQuestions : 0;
        let showAnimation = false;
        let isSafeZone = (!this.state.isShowAdaptivePopup) ? this.state.isSafeZone : false;


        let heading = (this.state.isPractice && this.state.isShowStartPopup) ?
            "You have already completed this session. You can get more practice with Math Buddy AI" :
            (remainingQuestion > 0) ? `${remainingQuestion} more questions to go. Are you sure` :
                (accuracy === 0) ? 'You need to practice a lot' :
                    (accuracy < 50) ? 'Can do better with practice' :
                        (accuracy < 80) ? 'Keep practicing. You can do better' :
                            (accuracy < 90) ? 'You did well. Try to score 100%' :
                                'Way to go! You were perfect!';

        if (this.state.questionsList.length && !this.state.isShowStartPopup && remainingQuestion === 0)
            showAnimation = true;


        return {
            streaks: this.state.streaks,
            accuracy: accuracy,
            totalAttemptedQuestions: this.state.totalAttemptedQuestions,
            completedStatusPercentage: this.state.completedStatusPercentage,
            isShowStartPopup: this.state.isShowStartPopup,
            isSafeZone,
            isSession: true,
            isCloseFromClick: this.state.isCloseFromClick,
            heading, showAnimation
        }
    }

    setShowAdaptivePopup = (isCloseFromClick: Boolean = false) => {
        let isShowAdaptivePopup = !this.state.isShowAdaptivePopup
        this.setState({ isCloseFromClick, isShowAdaptivePopup });
    }

    setShowStartPopup = (status: boolean) => {
        this.setState({ isShowStartPopup: status })
        if (!status)
            this.loadSessionContent();
    }

    sendLastAttemptedIfAny = async () => {
        let lastAttemptedData = this.props.adaptivePracticeReducer.lastAttemptedQuestion;
        if (lastAttemptedData.questions[0].answers.length) {
            this.setState({ isLoader: true });
            await this.saveQuestionResponseToDB(lastAttemptedData);
            this.setState({ isLoader: false });
        }
    }

    onClose = async () => {
        await this.sendLastAttemptedIfAny();
        this.context.messageForParent('close');
    }

    render() {
        return (
            <AdaptivePracticeContext.Provider value={{
                notificationMessage: this.state.notificationMessage,
                coins: this.state.coins,
                streaks: this.state.sessionInfo.isLiveMode ? undefined : this.state.streaks,
                isSafeZone: this.state.isSafeZone,
                isLastQuestion: this.state.isLastQuestion,
                meter: {
                    percentage: this.state.completedStatusPercentage,
                    level: this.state.adaptivePracticeLevel
                },
                isLoader: this.state.isLoader,
                isCoinAnimation: this.state.isCoinAnimation,
                isShowStartPopup: this.state.isShowStartPopup,
                isShowAdaptivePopup: this.state.isShowAdaptivePopup,
                isCloseFromClick: this.state.isCloseFromClick,
                engineObj: this.state.response,
                ...(this.state.sessionInfo.isLiveMode ? { options: { isShowClose: false, isShowExpNext: false } } : {}),
                loadContent: this.loadSessionContent,
                saveQuestionResponse: this.saveQuestionResponse,
                getPopUpInfo: this.getPopUpInfo,
                setShowAdaptivePopup: this.setShowAdaptivePopup,
                setShowStartPopup: this.setShowStartPopup,
                onclose: this.onClose
            }}>
                <PlayFrame></PlayFrame>
                {(this.state.isShowCorrectAnswerAnimation) && (
                    <img alt=""
                        style={{
                            position: "absolute",
                            width: "100vw",
                            height: "100vh",
                            top: "0px",
                            zIndex: "20"
                        }}
                        className="correctAnswerAnimation"
                        src={themeImage('mastry_animation.gif') + "?" + new Date().toDateString()}></img>
                )}
            </AdaptivePracticeContext.Provider>
        )
    }
}

function mapStateToProps(state: any) {
    return state;
}

let setAPLastAttempted = adaptivePracticeActions.setAPSessionLastAttempted;
let setAPDefaultLastAttempted = adaptivePracticeActions.setAPSessionDefaultLastAttempted;
let setAPSmartXpSession = adaptivePracticeActions.setAPSmartXpSession;


const mapDispatchToProps = { setAPLastAttempted, setAPDefaultLastAttempted, setAPSmartXpSession };

export default connect(mapStateToProps, mapDispatchToProps)(RiseSessionForStudents);